export default __webpack_public_path__ + "assets/mongolia-flag.png";